import axiosInstance from "../axiosInstance";

export const getMapCharacteristicsApi = (map_id) => {
  return axiosInstance.get(`/api/map/characteristics/${map_id}`);
};

export const addCharacteristicApi = (data) => {
  return axiosInstance.post(`/api/map/characteristics`, data);
};

export const changeRateApi = data => {
  return axiosInstance.post(`/api/map/characteristic-item/star`, data);
};
